import { render, staticRenderFns } from "./AwardWinners.vue?vue&type=template&id=833bca26&scoped=true&"
import script from "./AwardWinners.vue?vue&type=script&lang=js&"
export * from "./AwardWinners.vue?vue&type=script&lang=js&"
import style0 from "./AwardWinners.vue?vue&type=style&index=0&id=833bca26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833bca26",
  null
  
)

export default component.exports